import React from "react";
import { useTranslation } from "react-i18next";
import BrandNav from "../../components/BrandNav";

export default function RoboticsForParents() {
  const { t } = useTranslation();
  return (
    <>
      <BrandNav />
      <main className="ftg-page">
        <h1>{t("robotics.parents_title")}</h1>
        <p>{t("robotics.parents_subtitle")}</p>
      </main>
    </>
  );
}
